import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import omit from 'lodash/omit';
import { takeLatest, put } from 'redux-saga/effects';
import { DocumentResourceType } from 'data/documents';
import {
  TemplateObjectType,
  TemplatesAPI,
  TemplateState,
} from 'data/templates/api';
import { TaskTemplate } from 'data/templates/tasks';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  CreateDocumentTaskPayload,
  createDocumentTemplateTaskAction,
} from '../../actions';
import { updateDocumentTemplateTask } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';

function* createDocumentTemplateTask(
  action: PayloadAction<CreateDocumentTaskPayload>,
) {
  const {
    payload: {
      task,
      docId,
      resourceSectionId = floatUid(),
      resourceType = DocumentResourceType.Custom,
    },
  } = action;

  try {
    const taskId = floatUid();

    const _taskTemplate: TaskTemplate = {
      templateId: 'new',
      templateName: task.taskName,
      templateContent: {
        private: false,
        taskId,
        ...omit(task, ['resourceSectionId', 'resourceType']),
      },
      objectType: TemplateObjectType.Task,
      state: TemplateState.Published,
    };

    const taskTemplate: TaskTemplate = yield TemplatesAPI.save<TaskTemplate>(
      _taskTemplate,
    );

    yield put(
      updateDocumentTemplateTask({
        docId,
        resourceSectionId,
        resourceType,
        task: {
          ...taskTemplate.templateContent,
          taskId: taskTemplate.templateId as number,
        },
      }),
    );

    yield saveDocumentTemplate(docId);
  } catch (error) {
    logger.error(' an error creating a task in the document', { error });

    message.error('There was an error creating a task in the document');
  }
}
export const watchCreateDocumentTemplateTaskSaga = function* () {
  yield takeLatest(
    createDocumentTemplateTaskAction.type,
    createDocumentTemplateTask,
  );
};
